import UserComment from './UserComment.vue'

export default UserComment
